var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1539 5.07694C10.1539 8.30771 6.00004 11.0769 6.00004 11.0769C6.00004 11.0769 1.84619 8.30771 1.84619 5.07694C1.84619 3.97527 2.28383 2.91873 3.06282 2.13973C3.84182 1.36073 4.89837 0.923096 6.00004 0.923096C7.10171 0.923096 8.15825 1.36073 8.93725 2.13973C9.71625 2.91873 10.1539 3.97527 10.1539 5.07694Z",
    stroke: "#F1F1F1",
    strokeWidth: 0.923077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99997 6.46155C6.76467 6.46155 7.38459 5.84164 7.38459 5.07694C7.38459 4.31224 6.76467 3.69232 5.99997 3.69232C5.23527 3.69232 4.61536 4.31224 4.61536 5.07694C4.61536 5.84164 5.23527 6.46155 5.99997 6.46155Z",
    stroke: "#F1F1F1",
    strokeWidth: 0.923077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationVector);
export default __webpack_public_path__ + "static/media/locationVector.1d50ac5516667114e1d8aef0880c9e81.svg";
export { ForwardRef as ReactComponent };